import Swiper, {
	Grid,
	Thumbs,
	Autoplay,
	EffectFade,
	Mousewheel,
	Navigation,
	Pagination,
	Scrollbar,
} from "swiper";
import { lozadInit } from "./main";
import { animate, createTimeline, utils } from "animejs";
import noUiSlider from "nouislider";
import { rem } from "./ultil";
export function swiperInit() {
	let lastestVideo = null;
	const AUTO_PLAY_DELAY = 4500;
	const mainBannerAnimation = {
		tls: [],
		createTitle: function (swiper) {
			const slides = swiper.slides;
			if (!slides) return;
			slides.forEach((slide) => {
				const animateTexts = utils.$(
					slide.querySelectorAll(".animate-text")
				);
				const ellipse = utils.$(slide.querySelector(".ellipse-inner"));
				const img = utils.$(slide.querySelector("img"));

				const tl = createTimeline({
					autoplay: false,
					duration: 500,
					onComplete: () => {
						animateTexts.forEach((text) => {
							utils.set(text, {
								overflow: "visible",
							});
						});
					},
					onBegin: () => {
						animateTexts.forEach((text) => {
							text.classList.add("initialize");
							utils.set(text, {
								overflow: "hidden",
							});
						});
					},
				});
				animateTexts.forEach((text) => {
					const newWrap = document.createElement("div");
					newWrap.classList.add("animate-text-wrap");
					newWrap.innerHTML = text.innerHTML;
					text.textContent = "";
					text.appendChild(newWrap);
					utils.set(text, {
						overflow: "hidden",
					});
					utils.set(newWrap, {
						y: "100%",
						opacity: 0,
					});
					tl.add(
						newWrap,
						{
							y: 0,
							opacity: 1,
						},
						"<<"
					);
				});
				mainBannerAnimation.tls.push(tl);
			});
		},
		run: function (swiper) {
			const index = swiper.activeIndex;
			const tls = this.tls;
			if (tls.length === 0) return;
			tls.forEach((tl, tlIndex) => {
				let timeout = null;
				if (index === tlIndex) {
					clearTimeout(timeout);
					timeout = setTimeout(() => {
						tl.play();
					}, 500);
				}
			});
		},
		reset: function (swiper) {
			const index = swiper.activeIndex;
			const tls = this.tls;
			if (tls.length === 0) return;
			this.tls.forEach((tl, tlIndex) => {
				if (index === tlIndex) {
					return;
				}
				tl.reverse();
			});
		},
	};
	const main_banner = new Swiper(".main-banner .swiper", {
		modules: [Pagination, Autoplay, Navigation, EffectFade],
		effect: "fade",
		spaceBetween: 0,
		speed: 1000,
		// autoplay: {
		// 	delay: AUTO_PLAY_DELAY,
		// },
		observer: true,
		observeParents: true,
		navigation: {
			prevEl: `.main-banner .button-prev`,
			nextEl: `.main-banner .button-next`,
		},
		pagination: {
			el: `.main-banner .swiper-pagination`,
			clickable: true,
		},
		// allowTouchMove: false,
		on: {
			init: function () {
				handlePlayVideo(this);
				mainBannerAnimation.createTitle(this);
				mainBannerAnimation.run(this);
			},

			slideChange: function () {
				if (lastestVideo) {
					lastestVideo.pause();
					lastestVideo
						.closest(".main-banner")
						.classList.remove("active-video");
					lastestVideo
						.closest(".swiper-slide")
						.classList.remove("play-video");
					lastestVideo
						.closest(".swiper-slide")
						.classList.remove("active-video");
					lastestVideo
						.closest(".swiper-slide")
						.querySelector(".play-btn")
						?.classList.remove("active");
					lastestVideo.currentTime = 0;
				}
			},
			slideChangeTransitionStart: function () {
				mainBannerAnimation.reset(this);
			},
			slideChangeTransitionEnd: function () {
				handlePlayVideo(this);
				mainBannerAnimation.run(this);
			},
		},
	});

	function handlePlayVideo(swiper) {
		const index = swiper.activeIndex;
		const activeSlide = swiper.slides[index];
		const video = activeSlide.querySelector("video");
		if (!video) {
			swiper.params.autoplay.delay = AUTO_PLAY_DELAY;
			swiper.autoplay.stop();
			swiper.autoplay.start();

			return;
		}
		lastestVideo = video;
		let videoDuration = video.duration * 1000; // Convert to milliseconds
		swiper.params.autoplay.delay = videoDuration || AUTO_PLAY_DELAY;
		// console.log("time on other condition" + swiper.params.autoplay.delay);
		swiper.autoplay.stop();
		swiper.autoplay.start();

		let currentTime = 0;
		function autoPlay() {
			video.play();
			activeSlide.classList.add("play-video");
			swiper.el.closest(".main-banner").classList.add("active-video");
		}
		autoPlay();

		let isPlaying = video.paused === false;

		video.addEventListener("timeupdate", (event) => {
			videoDuration = video.duration;
			swiper.params.autoplay.delay = videoDuration;
			currentTime = event.target.currentTime;
			activeSlide.setAttribute("data-current-time", currentTime);
			activeSlide.setAttribute("data-duration", videoDuration);
			swiper.autoplay.stop();
		});
		let timeout = null;
		video.addEventListener("ended", () => {
			activeSlide.classList.remove("play-video");
			swiper.el.closest(".main-banner").classList.remove("active-video");

			clearTimeout(timeout);
			timeout = setTimeout(() => {
				swiper.slideNext();
				swiper.autoplay.start();
			}, 1000);
		});

		// const playButton = activeSlide.querySelector(".play-btn");
		// if (playButton && !playButton.classList.contains("init-event")) {
		// 	playButton.addEventListener("click", () => {
		// 		playButton.classList.add("init-event");
		// 		if (isPlaying) {
		// 			activeSlide.classList.remove("play-video");
		// 			swiper.el
		// 				.closest(".main-banner")
		// 				.classList.remove("active-video");
		// 			playButton.classList.remove("active");
		// 			video.pause();
		// 		} else {
		// 			playButton.classList.add("active");
		// 			swiper.el
		// 				.closest(".main-banner")
		// 				.classList.add("active-video");
		// 			activeSlide.classList.add("play-video");
		// 			video.play();
		// 		}

		// 		isPlaying = !isPlaying;
		// 	});
		// }
	}

	const page_banner = new Swiper(".page-banner .swiper", {
		modules: [Autoplay, EffectFade],
		effect: "fade",
		spaceBetween: 0,
		speed: 1000,
		autoplay: {
			delay: AUTO_PLAY_DELAY,
		},
		allowTouchMove: false,
		on: {
			autoplayTimeLeft: function (swiper, time, progress) {
				$(".page-banner .process-line").css({
					"--data-process": Math.abs(1 - progress) * 100 + "%",
				});
			},
		},
	});

	// **** Share layout slide **** //
	window.autoSwiper = [];
	$(".swiper-column-auto").each(function (e) {
		const $this = $(this);
		if ($this.hasClass("swiper-column-auto-2")) return;
		let isLoop = false;
		let isTouchMove = false;
		let isMouseWheel = false;
		let isAutoHeight = false;
		let isInsideNavMobile = false;
		if ($this.closest(".nav-mobile").length) {
			isInsideNavMobile = true;
		}
		if ($this.hasClass("swiper-loop")) {
			isLoop = true;
		}
		if ($this.hasClass("allow-touchMove")) {
			isTouchMove = true;
		}
		if ($this.hasClass("allow-mouseWheel")) {
			isMouseWheel = {
				forceToAxis: true,
			};
		}
		if ($this.hasClass("auto-height")) {
			isAutoHeight = true;
		}
		let isProductScrollbar = false;
		if ($this.hasClass("slide-product-scrollbar")) {
			isProductScrollbar = true;
		}
		let hasPointerHelper = false;
		if ($this.hasClass("has-pointer-helper")) {
			hasPointerHelper = true;
		}

		let time = $(this).attr("data-time") || 3500;

		const name = `swiper-column-auto-id-${e}`;
		$this.addClass(name);
		const rangeScrollBar = {
			slider: null,
			isDraging: false,
			createScrollbar: function (swiper) {
				if (rangeScrollBar.slider) return;
				const bullets = swiper.pagination.bullets;
				if (swiper.pagination.el === null) {
					throw new Error(
						`Pagination is null, stop creating scrollbar at ${name}`
					);
				}
				if (bullets.length === 0) {
					console.warn(
						`No bullets found, stop creating scrollbar at ${name}`
					);
					return;
				}
				var range = document.createElement("div");
				range.classList.add("range-scrollbar");
				if (bullets.length === 1) {
					range.classList.add("hidden");
				}
				try {
					$this.append(range);
				} catch (e) {
					console.log("Cannot append range", e);
				}
				const totalPagination = bullets.length - 1;

				const slider = noUiSlider.create(range, {
					start: [0],
					behaviour: "snap",
					range: {
						min: 0,
						max: totalPagination,
					},
				});
				const sliderEL = slider.target;
				if (hasPointerHelper) {
					const clonePointer = document
						.querySelector(".pointer-helper")
						.cloneNode(true);
					sliderEL.appendChild(clonePointer);
					const handIcon = clonePointer.querySelector(".hand-icon");
					const middleIcon =
						clonePointer.querySelector(".middle-icon");
					if (!handIcon || !middleIcon) return;
					const options = {
						x: [rem(-8), rem(8)],
						duration: 800,
						loop: true,
						ease: "inOutQuart",
						alternate: true,
					};
					animate(handIcon, {
						...options,
					});
					animate(middleIcon, {
						...options,
					});
				}
				slider.on("start", (value) => {
					rangeScrollBar.isDraging = true;
				});
				slider.on("end", (value) => {
					rangeScrollBar.isDraging = false;
					if (!rangeScrollBar.isDraging) {
						const moreThenToTheLeft =
							parseInt(value[0].split(".")[1]) < 50
								? true
								: false;
						const ceilValue = Math[
							moreThenToTheLeft ? "floor" : "ceil"
						](value[0]);
						slider.set(ceilValue);
					}
				});
				slider.on("update", (value) => {
					const moreThenToTheLeft =
						parseInt(value[0].split(".")[1]) < 50 ? true : false;
					const ceilValue = Math[
						moreThenToTheLeft ? "floor" : "ceil"
					](value[0]);
					const newBullets = swiper.pagination.bullets;
					newBullets[ceilValue].click();
				});
				this.slider = slider;
			},
			updateRange: function (swiper) {
				if (!this.slider && !this.slider) return;
				const bullets = swiper.pagination.bullets;
				const activePaginationIndex = Array.from(bullets).findIndex(
					(bullet) =>
						bullet.classList.contains(
							"swiper-pagination-bullet-active"
						)
				);
				this.slider.set(activePaginationIndex);
			},
		};

		const options = {
			modules: [Navigation, Pagination, Mousewheel, Scrollbar, Autoplay],
			speed: 500,
			observer: true,
			observeParents: true,
			spaceBetween: 0,
			loop: isLoop,
			slidesPerView: "auto",
			pagination: {
				el: `.swiper-column-auto-id-${e} .swiper-pagination`,
				clickable: true,
			},
			mousewheel: isMouseWheel,
			allowTouchMove: isTouchMove,
			navigation: {
				prevEl: `.swiper-column-auto-id-${e} .button-prev`,
				nextEl: `.swiper-column-auto-id-${e} .button-next`,
			},
			scrollbar: {
				el: `.swiper-column-auto-id-${e} .swiper-scrollbar`,
				hide: false,
				draggable: true,
			},
			watchSlidesProgress: true,
			autoHeight: isAutoHeight,
			on: {
				beforeInit: function () {
					window.autoSwiper.push(this);
				},
				init: function (swiper) {
					if (isLoop) {
						lozadInit();
						$(this.el)
							.find(".swiper-slide-duplicate a[data-fancybox]")
							.each(function () {
								$(this).removeAttr("data-fancybox");
							});
					}
				},
				afterInit: function () {
					//
				},
				slideChange: function () {
					if ($this.hasClass("auto-detect-video")) {
						$this.find("video")[0].pause();
						$this.find(".swiper-slide").removeClass("play-video");
						$this.find(".play-btn").removeClass("active");
					}
					if (
						isProductScrollbar &&
						!rangeScrollBar.isDraging &&
						$this.is(":visible")
					) {
						rangeScrollBar.updateRange(this);
					}
				},

				resize: function (swiper) {
					// console.log("resize ");
					const totalSlidesWidth = swiper.slidesSizesGrid.reduce(
						(acc, curr) => acc + curr,
						0
					);
					swiper.el.classList.toggle(
						"center-slide-active",
						totalSlidesWidth < swiper.size
					);
					autoSetSlidesPerGroup(this);
					if (isProductScrollbar) {
						rangeScrollBar.createScrollbar(this);
					}
				},
			},
		};

		if (time == 0) {
			options.autoplay = {
				delay: 0,
				disableOnInteraction: true,
				pauseOnMouseEnter: false,
			};
			options.loop = true;
			options.speed = 1800;
			delete options.navigation;
		}
		var swiper_column_auto = new Swiper(
			`.swiper-column-auto-id-${e} .swiper:not(.nested-swiper)`,
			{
				...options,
			}
		);

		if ($this.hasClass("auto-play")) {
			if (time != 0) {
				handleAutoplay(time, swiper_column_auto);
			}
		}

		if ($this.find(".swiper-pagination").length) {
			autoSetSlidesPerGroup(swiper_column_auto);
		}
		if (isInsideNavMobile) {
			swiper_column_auto.destroy();
		}
	});

	$(".home-grid-item").each(function (e) {
		const $this = $(this);
		const name = `home-grid-item-${e}`;
		$this.addClass(name);
		const home_grid_item = new Swiper(`.${name} .swiper`, {
			modules: [Autoplay, Grid, Pagination],
			grid: {
				fill: "row",
				rows: 2,
			},
			spaceBetween: 12,
			slidesPerView: 3,
			slidesPerGroup: 3,
			pagination: {
				el: `.${name} .swiper-pagination`,
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 12,
				},
				1024: {
					slidesPerView: 4,
					slidesPerGroup: 2,
					spaceBetween: 20,
				},
				1200: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 40,
				},
			},
			navigation: {
				prevEl: `.${name} .button-prev`,
				nextEl: `.${name} .button-next`,
			},
			// autoplay: {
			// 	delay: AUTO_PLAY_DELAY,
			// },
			on: {
				// autoplayTimeLeft: function (swiper, time, progress) {
				// 	$(".page-banner .process-line").css({
				// 		"--data-process": Math.abs(1 - progress) * 100 + "%",
				// 	});
				// },
			},
		});
		handleAutoplay(AUTO_PLAY_DELAY, home_grid_item);
	});

	function countSlide(swiper, parent) {
		const isLoop = swiper.params.loop;
		const totalSlide = isLoop
			? swiper.loopedSlides
			: swiper.el.querySelectorAll(".swiper-slide").length;
		let currentSlide = 0;
		// console.log(swiper.activeIndex, swiper.realIndex);
		if (swiper.activeIndex > totalSlide) {
			currentSlide = swiper.realIndex;
			if (swiper.realIndex === 0) {
				currentSlide = totalSlide;
			}
		} else {
			currentSlide = swiper.activeIndex;
		}
		// console.log("🟩 ~ countSlide ~ currentSlide:", currentSlide);
		const current = parent.find(".current");
		const total = parent.find(".total");
		if (current) {
			current.text(currentSlide + 1);
		}
		if (total) {
			total.text(totalSlide);
		}
	}

	$(".product-detail-1").each(function (e) {
		const name = `product-detail-1-${e}`;
		const $this = $(this);
		$this.addClass(name);
		// const centerIndex = $this.find(".thumb .swiper-slide").length - 1 || 0;
		var thumb = new Swiper(`.${name} .thumb .swiper`, {
			modules: [Mousewheel],
			speed: 500,
			observer: true,
			observeParents: true,
			spaceBetween: 0,
			slidesPerView: "auto",
			slideToClickedSlide: true,
			rewind: true,
		});
		var main = new Swiper(`.${name} .main .swiper`, {
			modules: [Thumbs, Navigation, Autoplay],
			spaceBetween: 0,
			slidesPerView: "auto",
			rewind: true,
			thumbs: {
				swiper: thumb,
			},
			speed: 500,
			observer: true,
			observeParents: true,
			autoHeight: true,
			navigation: {
				prevEl: `.${name} .button-prev`,
				nextEl: `.${name} .button-next`,
			},
			on: {
				slideChange: function () {
					autoSlideNextOnThumbSlide(this, `.${name}`, ".thumb");
				},
			},
		});
		handleAutoplay(AUTO_PLAY_DELAY, main);
	});
	$(".partner").each(function (e) {
		const name = `partner-${e}`;
		const $this = $(this);
		$this.addClass(name);
		// const centerIndex = $this.find(".thumb .swiper-slide").length - 1 || 0;
		var thumb = new Swiper(`.${name} .thumb .swiper`, {
			modules: [Mousewheel],
			speed: 500,
			observer: true,
			observeParents: true,
			spaceBetween: 0,
			slidesPerView: "auto",
			slideToClickedSlide: true,
			rewind: true,
		});
		var main = new Swiper(`.${name} .main .swiper`, {
			modules: [Thumbs, Navigation, Autoplay],
			spaceBetween: 0,
			slidesPerView: "auto",
			rewind: true,
			thumbs: {
				swiper: thumb,
			},
			speed: 500,
			observer: true,
			observeParents: true,
			autoHeight: true,
			navigation: {
				prevEl: `.${name} .button-prev`,
				nextEl: `.${name} .button-next`,
			},
			on: {
				slideChange: function () {
					autoSlideNextOnThumbSlide(this, `.${name}`, ".thumb");
				},
			},
		});
		handleAutoplay(AUTO_PLAY_DELAY, main);
	});
}
window.swiperInit = swiperInit;
function handleAutoplay(
	timeout,
	swiper,
	preventMouseEnter = false,
	thumbSwiper = null
) {
	if (!swiper || !swiper.el || !$(swiper.el).length) return;

	let stopSlideImmediate = $(swiper.el[0])
		.parent()
		.hasClass("auto-detect-video");
	if (stopSlideImmediate) return;

	const swiperSlides = swiper.slides;

	// Configure autoplay
	swiper.params.autoplay = {
		delay: timeout,
		disableOnInteraction: !preventMouseEnter,
		pauseOnMouseEnter: !preventMouseEnter,
	};

	swiper.autoplay.start();

	const navigationEl = swiper.params.navigation;
	if (navigationEl) {
		let isReachEnd = false;
		let isReachStart = false;

		swiper.on("beforeSlideChangeStart", function () {
			isReachEnd = swiper.isEnd;
			isReachStart = swiper.isBeginning;
		});

		$(navigationEl.prevEl).on("click", function () {
			if (isReachStart) return;

			swiper.autoplay.stop();
			swiper.autoplay.start();
			$(swiper.el).attr("data-auto-play", "stop");
		});

		$(navigationEl.nextEl).on("click", function () {
			if (isReachEnd) return;

			swiper.autoplay.stop();
			swiper.autoplay.start();
			$(swiper.el).attr("data-auto-play", "stop");
		});
	}

	if (thumbSwiper) {
		thumbSwiper.el.addEventListener("mouseenter", () => {
			swiper.autoplay.stop();
			$(swiper.el).attr("data-auto-play", "stop");
		});

		thumbSwiper.el.addEventListener("mouseleave", () => {
			swiper.autoplay.start();
		});
	}

	if (swiperSlides.length > 0) {
		swiperSlides.forEach((slide) => {
			slide.addEventListener("mouseenter", () => {
				swiper.autoplay.stop();
				$(swiper.el).attr("data-auto-play", "stop");
			});
			slide.addEventListener("mouseleave", () => {
				swiper.autoplay.start();
			});
		});
	}
}

function autoSlideNextOnThumbSlide(initSwiper, element, thumb) {
	let activeIndex = initSwiper.activeIndex + 1;
	let nextSlide = document.querySelector(
		`${element} ${thumb} .swiper-slide:nth-child(${activeIndex + 1})`
	);
	let prevSlide = document.querySelector(
		`${element} ${thumb} .swiper-slide:nth-child(${activeIndex - 1})`
	);
	if (nextSlide && !nextSlide.classList.contains("swiper-slide-visible")) {
		initSwiper.thumbs.swiper.slideNext();
	} else if (
		prevSlide &&
		!prevSlide.classList.contains("swiper-slide-visible")
	) {
		initSwiper.thumbs.swiper.slidePrev();
	}
}

function autoSetSlidesPerGroup(swiper) {
	if (!swiper.pagination.el) return;
	const { visibleSlidesIndexes, slidesSizesGrid } = swiper;
	const slidesPerGroup = getSlidesPerGroup(
		slidesSizesGrid,
		visibleSlidesIndexes
	);
	if (
		slidesPerGroup != null &&
		slidesPerGroup > 0 &&
		slidesPerGroup !== swiper.params.slidesPerGroup
	) {
		swiper.params.slidesPerGroup = slidesPerGroup;
		swiper.update();
	}
}

function getSlidesPerGroup(slidesSizesGrid, visibleSlidesIndexes) {
	const totalSlide = slidesSizesGrid.length;
	const visibleSlide = visibleSlidesIndexes?.length ?? 1;

	let slidesPerGroup = visibleSlide;

	if (totalSlide <= visibleSlide) {
		slidesPerGroup = null;
	}
	return slidesPerGroup;
}
